import { create } from "zustand";
export const useCouponStore = create((set, get)=>({
        appliedCoupons: {},
        applyCoupon: (productId, coupon)=>{
            const { appliedCoupons  } = get();
            // 기존에 이 쿠폰이 다른 상품에 적용돼있다면 제거
            const updated = Object.fromEntries(Object.entries(appliedCoupons).filter((param)=>{
                let [, appliedCoupon] = param;
                return appliedCoupon.couponId !== coupon.couponId;
            }));
            // 현재 상품에 새로운 쿠폰 적용
            updated[productId] = coupon;
            set({
                appliedCoupons: updated
            });
        },
        removeCoupon: (productId)=>{
            const { appliedCoupons  } = get();
            const { [productId]: _ , ...rest } = appliedCoupons;
            set({
                appliedCoupons: rest
            });
        },
        clearAllCoupons: ()=>{
            set({
                appliedCoupons: {}
            });
        }
    }));
